module.exports = __webpack_public_path__ + "static/24import-080f95def9919958ed54fb047555a8fa.png";